import bulkItemAPI from './bulkItemAPI';

export default {
  bulk: bulkItemAPI,
};
